import { DateTime } from '@ksyos/date-time';
import { TableCell, TableRow } from '@ksyos/design-system';
import type { IOrganizationPatientCountLogFrontEnd } from '@common/interfaces/organizationPatientCountLog';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { translateKey } from '@frontend/translate';

export function LogElement({
    id,
    modifierPractitionerName,
    newCount: updatedCount,
    referenceDate,
    modificationType,
    created_at,
}: IOrganizationPatientCountLogFrontEnd) {
    return (
        <TableRow key={id}>
            <TableCell>
                <NullableFormattedDate value={created_at} />
            </TableCell>
            <TableCell>{modifierPractitionerName}</TableCell>
            <TableCell>{translateKey(`organization.modal.logbookActionDescription.${modificationType}`)}</TableCell>
            <TableCell>{DateTime.from(referenceDate).format('D MMMM YYYY')}</TableCell>
            <TableCell>{updatedCount}</TableCell>
        </TableRow>
    );
}
